import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './Placeholder.module.css';

type Props = {
  className?: string;
  children: ReactNode;
};
export function Placeholder({ className, children }: Props) {
  return <div className={cx(styles.placeholder, className)}>{children}</div>;
}
